import { updateDOMAlertDataByIndex } from './components/alerts/alerts.data.templateParser.js';
import { sortPortfolio } from './components/portfolioAssets/portfolio.data.parse.js';
import { getAllAlertsFromServer } from './services/alerts.service.js';
import { getAllPortfolioData } from './services/assets.service.js';

var myassets = {};
var deltaabs = 'DELTA';

var mobilesubscriptionsData = {
	ep: 0,
	key: 0
};

$("[data-toggle='collapse']").click( function(e) {
	if ($('#main-wrapper').hasClass('show-sidebar') && window.innerWidth<992) {
		e.stopPropagation();
		$('.nav-toggler').trigger('click');
	}
	if ($('.right-sidebar').css('display') == 'block') {
		e.stopPropagation();
		$('.right-menu-toggler').trigger('click');
	}
});

 


$(document).on('click', function (e) {
	if ($('.right-sidebar').length > 0) {
		var menu_opened = $('.right-sidebar').css('display');
		if (menu_opened == 'block' && e.clientY > $('.right-sidebar').height()) {
			$('.right-menu-toggler').trigger('click');
		}
	}
	if ($('.left-sidebar').length > 0) {
		var menu_opened = $('.left-sidebar').position().left;
		if ($('#main-wrapper').hasClass('show-sidebar') && menu_opened >= 0 && e.clientX > $('.left-sidebar').width()) {
			$('.nav-toggler').trigger('click');		
		}
	}
	$('.flash-alert-box-wrapper').each(function (index) {
		this.remove();
	});
});



/* include thousands separator in number within class/span */
export function makeThousandSpacers() {	
	$('.thousand-spacer').each(function () {
		if (!$(this).hasClass('parsedValue')) {
			var dec_seperatior = I18n['dec_seperator'];
			var thousand_seperator = I18n['thousand_seperator'];
			var number = $(this).text();
			var numberParts = new Array;
			numberParts = number.split('.');
			numberParts[0] = numberParts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousand_seperator);				
			var output = numberParts[1] ? numberParts[0]+dec_seperatior+numberParts[1] : numberParts[0];
			$(this).text(output);
			$(this).css('white-space','nowrap');
			$(this).addClass('parsedValue');
		}
	});
}

/* calc asset-info from graphdata */
$(function () {
	$('.info_item').on('click', function () {
		
	});
});



export function RailsViewReady(controller, action) {	
	
	return new Promise(function (resolve, reject) {
		if (action.length) {
			if ($('body').hasClass(controller)) {
				if ($('body').hasClass(action)) {
					resolve();
					return true;
				} else {
					reject();
					return false;
				}
			}
			else {
				reject();
				return false;
			}
		}
		if (!action.length) {
			if ($('body').hasClass(controller)) {
				resolve();
				return true;
			}
			else {
				reject();
				return false;
			}
		}
	});
}

export function syncLoadCommunityAlerts() {
	getAllPortfolioData().then(function (res1) {
		getAllAlertsFromServer('communityalerts').then(function (res) {
			console.log(useralerts);
			if (typeof useralerts !== 'undefined') { for (var i = 0; i < useralerts.length; i++) updateDOMAlertDataByIndex(i, useralerts[i]); }
			updateDOMForCommunityRequirements();
		});
	});
}

export function updateDOMForCommunityRequirements() {
	$('.edit-alert').each(function () {
		$(this).remove();
	});
	$('.delete-alert').each(function () {
		$(this).remove();
	});
	$('.infomail-alert').each(function () {
		$(this).remove();
	});
	$('.nonactive-alert').each(function () {
		$(this).removeClass('nonactive-alert');
		$(this).addClass('active-alert');
	});

}

export async function syncLoadAlertsAndAssets() {
	return new Promise(function (resolve, reject) {
		getAllPortfolioData().then(function (res) {
			sortPortfolio();
			getAllAlertsFromServer('useralerts').then(function (res2) {
				$('.creditpoints').each(function () {
					if (creditpoints.accounttype == 'premium') {						
						$(document).find('.creditpoints-text').html(parseFloat(creditpoints.left/creditpoints.in_currency).toFixed(2) + ' ' + creditpoints.currency + ' <small>(' + I18n['header_monthly_cost'] + ': ' + parseFloat(creditpoints.monthlycosts / creditpoints.in_currency).toFixed(2) + ' ' + creditpoints.currency + ')</small>');
						if ($(this).css('display') == 'block') {
							$(this).css('display', 'none');
							$(this).css('opacity', '1');
							$(this).fadeIn(400);
						}
					}
				});
				resolve();
			}).catch(function(err) {
				/* check login status === false*/
				window.location.href = window.location.href;	
			});
		}).catch(function(err) {
			/* check login status === false*/
			window.location.href = window.location.href;
		});
	});
}

export function scrollToLatestAsset() {
	if (scrollTo > -1) {
		useralerts.forEach(function (item, ix) {
			if (item.id == scrollTo) {
				$('html, body').animate({
					scrollTop: $('#' + item.index).parent().offset().top - $('.alerts-header-content').height()
				}, 1200);
			scrollTo = -1;
			}	
		});
	}
	if (!!scrollToAsset && scrollToAsset > -1) {
		userassets.forEach(function (item, ix) {
			if (ix>0 && item.core_asset_id == scrollToAsset) {
				$('html, body').animate({
					scrollTop: $('#portfolioCard_' + ix).offset().top - $('.alerts-header').height() - 100
				}, 1200);
			scrollToAsset = -1;
			}
		});
	}
}

export async function cleanUpDOMList(num, idname, classname, force) {
	return new Promise(function (resolve, reject) {
		var DOMarray = $(classname);
		var len = DOMarray.length;
		var diff = num-len;

		var portfolio_element = $('#alerts-portfolio-wrapper');
		var sort_element = $('#portfolio-sort-controls').detach();
		sort_element.toggle(num > 0);

		if (force) {
			$('.alerts-insert').html('');
			diff = num;
			num = 0;
			$(portfolio_element).appendTo('.alerts-insert');
			sort_element.appendTo('.alerts-insert');
		} else {
			sort_element.insertAfter(portfolio_element);
			num--;
		}

		if (diff > 0) {
			for (var i=0;i<diff;i++) {
				var rowTemplate = _.template(template_items_on_portfolio);
				var compiledTemplate = rowTemplate({ index: num+i });
				var nel = $.parseHTML(compiledTemplate);
				$.when($(nel).appendTo('.alerts-insert'))
				 .then( resolve() );
			}
		}
		if (diff < 0) {
			for (var i=0;i<-diff;i++) {
				var nel = DOMarray.last();
				$.when($(nel).remove())
				 .then( resolve() );
			}
		}
		if (diff == 0) resolve();
	});
}
